import eventBus from '../../../../services/eventBus'
import { IParameter } from '../../parameters.types'

const created = (parameter: IParameter) => {
  eventBus.pub('parameter.created', parameter)
}

const updated = (parameter: IParameter) => {
  eventBus.pub('parameter.updated', parameter)
}

const deleted = (id: IParameter['id']) => {
  eventBus.pub('parameter.deleted', id)
}
const parameterEvents = { created, updated, deleted }
export default parameterEvents
